import { ApiClient } from '@k2/common/backend/api-client';
import { AssignmentIdentity } from '@k2/common/entities-state/types';
import { map } from 'rxjs/operators';
import {
  LinkAssignmentDialogData
} from "@k2/staff/content/clients/client/profile/overview/assignments/link-assignment-dialog/link-assignment-dialog.component";
import {Observable} from "rxjs";
import {FormSpec} from "@k2/common/k2-forms-state/types";

export class ClientAssignmentsEndpoint {
  constructor(private api: ApiClient) {}

  fetchAssignment = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(`/clients/${clientId}/assignment/${assignmentId}/analysis/overview`);
  };

  fetchAssignments = (clientId: number) => {
    return this.api
      .get(`/clients/${clientId}/assignments`)
      .pipe(map(payload => payload.assignments));
  };

  fetchSoonAssignments = (userId: number, type: 'starting' | 'ending') => {
    return this.api
      .get(`/clients/${userId}/assignments/soon/${type}`)
      .pipe(map(payload => payload.assignments));
  };

  fetchAssignmentStatuses = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api
      .get(`/clients/${clientId}/assignment/${assignmentId}/statuses`)
      .pipe(map(payload => payload.statuses));
  };

  patchAssignmentStatus = ({ clientId, assignmentId }: AssignmentIdentity, statusId: number) => {
    const data = { k2_status_id: statusId };
    return this.api.patch(`/clients/${clientId}/assignment/${assignmentId}/status`, data);
  };

  fetchAssignmentLinks = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(`/clients/${clientId}/assignment/${assignmentId}/links`);
  };

  fetchNewAssignmentLinkForm = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api
      .get(`/clients/${clientId}/assignment/${assignmentId}/links/new`)
      .pipe(map(payload => payload.form));
  };

  updateNewAssignmentLink = ({ clientId, assignmentId }: AssignmentIdentity, data: any) => {
    return this.api.post(`/clients/${clientId}/assignment/${assignmentId}/link`, data);
  };

  deleteLink = (clientId: number, assignmentId: number, linkedAssignmentId: number) => {
    return this.api.delete(
      `/clients/${clientId}/assignment/${assignmentId}/link/${linkedAssignmentId}`
    );
  };

  fetchDataForLinkAssignments(assignment: LinkAssignmentDialogData): Observable<FormSpec> {
    return this.api.get(`/clients/${assignment.clientId}/assignment/${assignment.assignmentId}/link-with-external/${assignment.linkingAssignmentType}/form`)
      .pipe(map(response => response.form));
  };

  linkExternalAssignment(assignment: LinkAssignmentDialogData, targetAssignmentId: number): Observable<FormSpec> {
    return this.api.post(`/clients/${assignment.clientId}/assignment/${targetAssignmentId}/externalAssignmentId/${assignment.assignmentId}/link-with-external`, {
      type: assignment.linkingAssignmentType
    })
      .pipe(map(response => response.form));
  };

  fetchCloseDetails = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(`/clients/${clientId}/assignment/${assignmentId}/close`);
  };

  updateCloseReason = ({ clientId, assignmentId }: AssignmentIdentity, data) => {
    return this.api.patch(`/clients/${clientId}/assignment/${assignmentId}/close`, data);
  };

  reopenAssignment = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.patch(`/clients/${clientId}/assignment/${assignmentId}/reopen`, null);
  };

  deleteAssignment = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.delete(`/clients/${clientId}/assignment/${assignmentId}`);
  };

  fetchServiceAddons = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(`/clients/${clientId}/assignment/${assignmentId}/service/addons/list`);
  };

  updateEnabledServiceAddons = ({ clientId, assignmentId }: AssignmentIdentity, data) => {
    return this.api.post(`/clients/${clientId}/assignment/${assignmentId}/service/addons`, data);
  };

  fetchPackages = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(`/clients/${clientId}/assignment/${assignmentId}/packages`);
  };
}
